export default __webpack_public_path__ + "static/media/5_3dots.a2222b8c.svg";